import React, { useState, useEffect, useRef } from 'react';
import './WeekButtons.css';

const WeekButtons = ({ handleWeekClick, status }) => {
    const [activeWeek, setActiveWeek] = useState(null);
    const scrollContainerRef = useRef(null);

    const preseason = true;

    useEffect(() => {
        const currentDate = new Date();
        const weeks = [];
        const dates = [
            /*'Aug 1 - Aug 5',
            'Aug 6 - Aug 12',
            'Aug 13 - Aug 19',
            'Aug 20 - Aug 26',*/
            'Sep 1 - Sep 15',
            'Sep 16 - Sep 22',
            'Sep 23 - Sep 29',
            'Sep 30 - Oct 6',
            'Oct 7 - Oct 13',
            'Oct 14 - Oct 20',
            'Oct 21 - Oct 27',
            'Oct 28 - Nov 3',
            'Nov 4 - Nov 10',
            'Nov 11 - Nov 17',
            'Nov 18 - Nov 24',
            'Nov 25 - Dec 1',
            'Dec 2 - Dec 8',
            'Dec 9 - Dec 15',
            'Dec 16 - Dec 22',
            'Dec 23 - Dec 29',
            'Dec 30 - Jan 5',
            'Dec 6 - Jan 12',
            'Jan 13 - Jan 19',
            'Jan 20 - Jan 26',
            'Jan 27 - Feb 2',
            'May 1 - May 2',
            'Feb 3 - Mar 1',
            // Add more custom date ranges as needed
        ];



        dates.forEach((dateRange, index) => {
            const [startDateStr, endDateStr] = dateRange.split(' - ');
            var year = "2026";
            if (startDateStr.includes("Jan") || startDateStr.includes("Feb")) {
                year = "2027";
            }
            const startDate = new Date(startDateStr + ", " + year);
            if (endDateStr.includes("Jan") || endDateStr.includes("Feb")) {
                year = "2027";
            }
            else {
                year = "2026";
            }
            const endDate = new Date(endDateStr + ", " + year);
            endDate.setDate(endDate.getDate() + 1); // Including end date
            weeks.push({ startDate, endDate });
        });

        var weekIndex = weeks.findIndex((week) => currentDate >= week.startDate && currentDate <= week.endDate);

        if (weekIndex === -1) {
            weekIndex = 0;
        }
        //weekIndex -= 6;
        handleButtonClick(weekIndex + 1);
        /*setActiveWeek(weekIndex + 1);
        handleWeekClick(weekIndex + 1);
        weekIndex = Math.min(weekIndex, 22);
        // Scroll to the center of the active button
        if (scrollContainerRef.current) {
            const containerWidth = scrollContainerRef.current.offsetWidth;
            const button = scrollContainerRef.current.children[weekIndex];
            const buttonWidth = button.offsetWidth;
            const scrollLeft = button.offsetLeft - (containerWidth / 2) + (buttonWidth / 2);
            scrollContainerRef.current.scrollLeft = scrollLeft;
        }*/
    }, []);

    const handleButtonClick = (index) => {

                setActiveWeek(index);
                        handleWeekClick(index);


        if(preseason && index < 1){
            index = index + 6;
        }else if(preseason){
            index = index + 4;
        }

        index = Math.min(index, 24);


        // Scroll to the center of the clicked button
        if (scrollContainerRef.current && index > -6) {
            const containerWidth = scrollContainerRef.current.offsetWidth;
            if (index < 0) {
                index += 2;
            }
            const button = scrollContainerRef.current.children[index - 1 + 0];
            const buttonWidth = button.offsetWidth;
            const scrollLeft = button.offsetLeft - (containerWidth / 2) + (buttonWidth / 2);
            scrollContainerRef.current.scrollLeft = scrollLeft;
        }
    };

    const dates = [
        'Sep 9 - Sep 15',
        'Sep 16 - Sep 22',
        'Sep 23 - Sep 29',
        'Sep 30 - Oct 6',
        'Oct 7 - Oct 13',
        'Oct 14 - Oct 20',
        'Oct 21 - Oct 27',
        'Oct 28 - Nov 3',
        'Nov 4 - Nov 10',
        'Nov 11 - Nov 17',
        'Nov 18 - Nov 24',
        'Nov 25 - Dec 1',
        'Dec 2 - Dec 8',
        'Dec 9 - Dec 15',
        'Dec 16 - Dec 22',
        'Dec 23 - Dec 29',
        'Dec 30 - Jan 5',
        'Dec 6 - Jan 12',
        // Add more custom date ranges as needed
    ];
    const weekButtons = dates.map((dateRange, index) => (
        <button
            key={index + 1}
            className={`${activeWeek === index + 1 ? 'active-week' : ''} ${status === "loading" ? 'disabled' : ''}`}
            onClick={() => handleButtonClick(index + 1)}
        >
            Week {index + 1}
            <br />
            <span className="week-dates">{dateRange}</span>
        </button>
    ));

    return (
        <div className="week-buttons" ref={scrollContainerRef}>
            <button className={`${activeWeek === -5 ? 'active-week preseason' : 'preseason'} ${status === "loading" ? 'disabled' : ''}`} onClick={() => handleButtonClick(-5)}>HOF<br /><span className="week-dates">Jul 30 - Aug 5</span></button>
            <button className={`${activeWeek === -4 ? 'active-week preseason' : 'preseason'} ${status === "loading" ? 'disabled' : ''}`} onClick={() => handleButtonClick(-4)}>Preseason 1<br /><span className="week-dates">Aug 6 - Aug 12</span></button>
            <button className={`${activeWeek === -3 ? 'active-week preseason' : 'preseason'} ${status === "loading" ? 'disabled' : ''}`} onClick={() => handleButtonClick(-3)}>Preseason 2<br /><span className="week-dates">Aug 13 - Aug 19</span></button>
            <button className={`${activeWeek === -2 ? 'active-week preseason' : 'preseason'} ${status === "loading" ? 'disabled' : ''}`} onClick={() => handleButtonClick(-2)}>Preseason 3<br /><span className="week-dates">Aug 20 - Aug 26</span></button>
            
            {weekButtons}
            <button
                className={`${activeWeek === 19 ? 'active-week' : ''} ${status === "loading" ? 'disabled' : ''}`}
                onClick={() => handleButtonClick(19)}>
                Wild Card
                <br />
                <span className="week-dates">Jan 13 - Jan 19</span>
            </button>
            <button className={`${activeWeek === 20 ? 'active-week' : ''} ${status === "loading" ? 'disabled' : ''}`} onClick={() => handleButtonClick(20)}>Div Rd<br /><span className="week-dates">Jan 20 - Jan 26</span></button>
            <button className={`${activeWeek === 21 ? 'active-week' : ''} ${status === "loading" ? 'disabled' : ''}`} onClick={() => handleButtonClick(21)}>Conf Champ<br /><span className="week-dates">Jan 27 - Feb 2</span></button>
            <button className={`${activeWeek === 23 ? 'active-week' : ''} ${status === "loading" ? 'disabled' : ''}`} onClick={() => handleButtonClick(23)}>Super Bowl<br /><span className="week-dates">Feb 14, 2027</span></button>
        </div>
    );
};

export default WeekButtons;